import { registerView, View, ViewComponent } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import * as React from "react";
import PaymentViewModel from "../../../../viewModels/eshop/order/components/paymentViewModel";

const PaymentView: ViewComponent<PaymentViewModel> = observer(({ vm }) => {
  return (
    <fieldset>
      {vm.children.map((children, index) => {
        return <Observer key={index}>{() => <View vm={children} />}</Observer>;
      })}
    </fieldset>
  );
});

registerView(PaymentView, PaymentViewModel);
